// Per-program wording for work logs. Interns do credited work; volunteers log
// service done outside an event; instructors log the classes they taught. The
// entry panel, the dashboard and the history page all read from here so one
// program's logs carry the same names everywhere.
// Volunteers only use the entry panel (their dashboard and Service History page
// are their own), so theirs has just the panel fields.
export const WORK_LOG_COPY = {
    internship: {
        title: "Work",
        column: "Work",
        placeholder: "what you worked on",
        hoursLabel: "WORKING TIME",
        daysLabel: "DAYS WORKED",
        noApproved: "No approved work yet.",
        historyPath: "/mypage/work-history",
        historyTitle: "Work History",
        historyEmpty: "No work logs yet.",
        historyNoMatch: "No work logs match.",
        historySearch: "Search work logs",
        historyError: "Couldn't load your work log. Please try again later.",
    },
    volunteer: {
        title: "Independent Service",
        // Too wide for 40px on a phone; the panel has room for it from sm up.
        titleClass: "text-[24px] sm:text-[40px]",
        column: "Activity",
        placeholder: "what you did",
    },
    instruction: {
        title: "Teaching",
        column: "Class",
        placeholder: "which class and what you taught",
        hoursLabel: "TEACHING TIME",
        daysLabel: "DAYS TAUGHT",
        noApproved: "No approved classes yet.",
        historyPath: "/mypage/teaching-history",
        historyTitle: "Teaching History",
        historyEmpty: "No classes logged yet.",
        historyNoMatch: "No classes match.",
        historySearch: "Search class logs",
        historyError: "Couldn't load your teaching log. Please try again later.",
    },
};
